// extracted by mini-css-extract-plugin
var _1 = "RequestBoardCardLocation-moduleRequestBoardCardLocation__nDog0";
export { _1 as "RequestBoardCardLocation" }
